import ErrorBoundary from '@/components/ErrorBoundary';
import {AuthProvider} from '@/contexts/AuthContext';
import {Outlet, RouterProvider, createBrowserRouter} from 'react-router-dom';
import {PostHogIdentity} from '@/components/PostHogIdentity';
import {QueryClient, QueryClientProvider} from '@tanstack/react-query';
import {ThemeProvider} from '@/contexts/ThemeContext';
import {routes} from '@/router';

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
            retry: 1,
            staleTime: 30000
        }
    }
});

const router = createBrowserRouter([
    {
        element: (
            <>
                <PostHogIdentity />
                <Outlet />
            </>
        ),
        children: routes
    }
]);

function App() {
    return (
        <ErrorBoundary>
            <ThemeProvider>
                <QueryClientProvider client={queryClient}>
                    <AuthProvider>
                        <RouterProvider router={router} />
                    </AuthProvider>
                </QueryClientProvider>
            </ThemeProvider>
        </ErrorBoundary>
    );
}

export default App;
